import React from 'react';
import classnames from 'classnames';
import { ThemeOverride } from '@wix/da-shared-react/pkg//Context';
import { ThemeOptions } from '@wix/da-shared-react/pkg/publicSession/types';
import bindOwnClassnamesWithSkin from '@wix/da-shared-react/pkg/utils/bindOwnClassnamesWithSkin';
import Tooltip from '@wix/da-shared-react/pkg/Tooltip';

import s from './ConfigPopover.scss';

export interface Props {
  width?: number;
  withPaddings?: boolean;
  className?: string;
  skin?: { [k: string]: string };
  onClose(): void;
}

export class ConfigPopover extends React.Component<Props> {
  static defaultProps = {
    withPaddings: true,
    skin: {},
  };

  private s: Function;

  constructor(props) {
    super(props);
    this.s = bindOwnClassnamesWithSkin(s, props.skin);
  }

  render() {
    const { withPaddings, width, className, onClose, children } = this.props;
    return (
      <Tooltip
        isOpen={true}
        positionFixed={true}
        width={width}
        onClickOutside={onClose}
        showArrow={false}
        wrapperClassName={classnames(
          'no-theme-skin',
          this.s('tooltip-wrapper'),
          className
        )}
        contentClassName={classnames(
          this.s('tooltip-content'),
          withPaddings && this.s('with-paddings')
        )}
        placement="bottom-end"
        positionOnly
      >
        <ThemeOverride
          className={classnames('no-theme-skin', this.s('theme-wrapper'))}
          theme={ThemeOptions.LIGHT}
        >
          {children}
        </ThemeOverride>
      </Tooltip>
    );
  }
}

export default ConfigPopover;
